import { lazy } from "react";
import { getStandaloneComponentRenderer } from "@kaltura/mediaspace-shared-layout";

const WaitingRoom = lazy(() => import("@mediaspace-react-components/features-waiting-room"));

export const render = getStandaloneComponentRenderer(WaitingRoom);
